import { useState } from "react";
import { ChevronDown } from "lucide-react";
import { cn } from "@/lib/utils";

/**
 * Sharp-edged FAQ accordion. Click to toggle. Cyan accent on open.
 * Items: [{ q, a }]
 */
const FAQAccordion = ({ items = [], testidPrefix = "faq" }) => {
    const [openIdx, setOpenIdx] = useState(0);

    return (
        <div className="divide-y divide-brand-dark/10 border-y border-brand-dark/10" data-testid={`${testidPrefix}-list`}>
            {items.map((item, i) => {
                const open = openIdx === i;
                return (
                    <div key={i} data-testid={`${testidPrefix}-item-${i}`}>
                        <button
                            type="button"
                            onClick={() => setOpenIdx(open ? -1 : i)}
                            className={cn(
                                "w-full flex items-start justify-between gap-4 py-5 md:py-6 text-left transition-colors duration-200",
                                open ? "text-brand-cyan" : "text-brand-dark hover:text-brand-cyan",
                            )}
                            aria-expanded={open}
                            data-testid={`${testidPrefix}-toggle-${i}`}
                        >
                            <span className="font-sans font-bold text-base md:text-lg leading-snug">
                                {item.q}
                            </span>
                            <ChevronDown
                                className={cn(
                                    "h-5 w-5 shrink-0 mt-1 transition-transform duration-200",
                                    open && "rotate-180",
                                )}
                                strokeWidth={2.25}
                            />
                        </button>
                        <div
                            className={cn(
                                "overflow-hidden transition-all duration-300 ease-out",
                                open ? "max-h-96 opacity-100 pb-6" : "max-h-0 opacity-0",
                            )}
                        >
                            <div className="border-l-2 border-brand-cyan pl-4 ml-1">
                                <p className="text-base text-brand-dark/80 leading-relaxed">
                                    {item.a}
                                </p>
                            </div>
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

export default FAQAccordion;
